module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_new07.62a904fa.jpg";